/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { DeleteNoteRequest } from '../models';
import { NoteIEnumerableResponse } from '../models';
import { NoteRequest } from '../models';
import { NotesFilterRequest } from '../models';
import { ReviewOfficeNotesResponse } from '../models';
import { ScratchpadRequest } from '../models';
import { ScratchpadResponse } from '../models';
/**
 * NotesApi - axios parameter creator
 * @export
 */
export const NotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns boolean
         * @param {DeleteNoteRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesDeleteNotePost: async (body?: DeleteNoteRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Notes/DeleteNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Notes
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesGetNotesByInvestigationIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2NotesGetNotesByInvestigationIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Notes/GetNotesByInvestigationId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns LeaveTypes
         * @param {NotesFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesGetNotesByPracticeIdPost: async (body?: NotesFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Notes/GetNotesByPracticeId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns ReviewOfficeNotes
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesGetReviewOfficeNotesByInvestigationIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2NotesGetReviewOfficeNotesByInvestigationIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Notes/GetReviewOfficeNotesByInvestigationId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Scratchpad
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesGetScratchpadInvestigationIdPost: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2NotesGetScratchpadInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Notes/GetScratchpad/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {NoteRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesSaveNotePost: async (body?: NoteRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Notes/SaveNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {ScratchpadRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesSaveScratchpadPost: async (body?: ScratchpadRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Notes/SaveScratchpad`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotesApi - functional programming interface
 * @export
 */
export const NotesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns boolean
         * @param {DeleteNoteRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2NotesDeleteNotePost(body?: DeleteNoteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await NotesApiAxiosParamCreator(configuration).apiV2NotesDeleteNotePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Notes
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2NotesGetNotesByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteIEnumerableResponse>> {
            const localVarAxiosArgs = await NotesApiAxiosParamCreator(configuration).apiV2NotesGetNotesByInvestigationIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns LeaveTypes
         * @param {NotesFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2NotesGetNotesByPracticeIdPost(body?: NotesFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteIEnumerableResponse>> {
            const localVarAxiosArgs = await NotesApiAxiosParamCreator(configuration).apiV2NotesGetNotesByPracticeIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns ReviewOfficeNotes
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2NotesGetReviewOfficeNotesByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewOfficeNotesResponse>> {
            const localVarAxiosArgs = await NotesApiAxiosParamCreator(configuration).apiV2NotesGetReviewOfficeNotesByInvestigationIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Scratchpad
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2NotesGetScratchpadInvestigationIdPost(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScratchpadResponse>> {
            const localVarAxiosArgs = await NotesApiAxiosParamCreator(configuration).apiV2NotesGetScratchpadInvestigationIdPost(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {NoteRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2NotesSaveNotePost(body?: NoteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await NotesApiAxiosParamCreator(configuration).apiV2NotesSaveNotePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {ScratchpadRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2NotesSaveScratchpadPost(body?: ScratchpadRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await NotesApiAxiosParamCreator(configuration).apiV2NotesSaveScratchpadPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NotesApi - factory interface
 * @export
 */
export const NotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns boolean
         * @param {DeleteNoteRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesDeleteNotePost(body?: DeleteNoteRequest, options?: any): AxiosPromise<BooleanResponse> {
            return NotesApiFp(configuration).apiV2NotesDeleteNotePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Notes
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesGetNotesByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<NoteIEnumerableResponse> {
            return NotesApiFp(configuration).apiV2NotesGetNotesByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns LeaveTypes
         * @param {NotesFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesGetNotesByPracticeIdPost(body?: NotesFilterRequest, options?: any): AxiosPromise<NoteIEnumerableResponse> {
            return NotesApiFp(configuration).apiV2NotesGetNotesByPracticeIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns ReviewOfficeNotes
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesGetReviewOfficeNotesByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<ReviewOfficeNotesResponse> {
            return NotesApiFp(configuration).apiV2NotesGetReviewOfficeNotesByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Scratchpad
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesGetScratchpadInvestigationIdPost(investigationId: number, options?: any): AxiosPromise<ScratchpadResponse> {
            return NotesApiFp(configuration).apiV2NotesGetScratchpadInvestigationIdPost(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean
         * @param {NoteRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesSaveNotePost(body?: NoteRequest, options?: any): AxiosPromise<BooleanResponse> {
            return NotesApiFp(configuration).apiV2NotesSaveNotePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {ScratchpadRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2NotesSaveScratchpadPost(body?: ScratchpadRequest, options?: any): AxiosPromise<BooleanResponse> {
            return NotesApiFp(configuration).apiV2NotesSaveScratchpadPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotesApi - object-oriented interface
 * @export
 * @class NotesApi
 * @extends {BaseAPI}
 */
export class NotesApi extends BaseAPI {
    /**
     * 
     * @summary Returns boolean
     * @param {DeleteNoteRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiV2NotesDeleteNotePost(body?: DeleteNoteRequest, options?: any) {
        return NotesApiFp(this.configuration).apiV2NotesDeleteNotePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Notes
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiV2NotesGetNotesByInvestigationIdInvestigationIdGet(investigationId: number, options?: any) {
        return NotesApiFp(this.configuration).apiV2NotesGetNotesByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns LeaveTypes
     * @param {NotesFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiV2NotesGetNotesByPracticeIdPost(body?: NotesFilterRequest, options?: any) {
        return NotesApiFp(this.configuration).apiV2NotesGetNotesByPracticeIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns ReviewOfficeNotes
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiV2NotesGetReviewOfficeNotesByInvestigationIdInvestigationIdGet(investigationId: number, options?: any) {
        return NotesApiFp(this.configuration).apiV2NotesGetReviewOfficeNotesByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Scratchpad
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiV2NotesGetScratchpadInvestigationIdPost(investigationId: number, options?: any) {
        return NotesApiFp(this.configuration).apiV2NotesGetScratchpadInvestigationIdPost(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean
     * @param {NoteRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiV2NotesSaveNotePost(body?: NoteRequest, options?: any) {
        return NotesApiFp(this.configuration).apiV2NotesSaveNotePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value
     * @param {ScratchpadRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public apiV2NotesSaveScratchpadPost(body?: ScratchpadRequest, options?: any) {
        return NotesApiFp(this.configuration).apiV2NotesSaveScratchpadPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
